import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=c71f14e8&scoped=true&"
import script from "./GoodsDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDetail.vue?vue&type=style&index=0&id=c71f14e8&lang=scss&scoped=true&"
import style1 from "./GoodsDetail.vue?vue&type=style&index=1&id=c71f14e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71f14e8",
  null
  
)

export default component.exports